module.exports = __webpack_public_path__ + "img/w1_7.c08f26f6.png";